import { ValidatorFn, Validators } from '@angular/forms';

export const legalAgeValidator: ValidatorFn = (control) => {
  if (!!control.value === false) return null;
  const today = new Date().getTime();
  const birthday = new Date(control.value).getTime();
  const years = (today - birthday) / 1000 / 60 / 60 / 24 / 365;
  return years < 18 ? { legalAge: true } : null;
};

export const BIRTHDAY_VALIDATORS = [Validators.required, legalAgeValidator];
